
const treeMaskReducer = (state = {}, action) => {
    switch (action.type) {
        case 'SET_TREE_MASK':
            return action.payload;
        default:
            return state;
    }
}

export default treeMaskReducer;